import React from 'react';
import { Wind } from 'lucide-react';
import { AudioEffect, AudioEffectControlProps } from './AudioEffect';
import { AudioSourceRegistry } from '../../../../dataTypes/liveStreamManagment/audioPipeline/AudioSourceRegistry';
import { LevelSlider } from '../LevelSlider';

export interface LowcutConfig {
  /** Fréquence de coupure, en Hz. */
  freq: number;
}

class LowcutEffectImpl extends AudioEffect<LowcutConfig> {
  readonly id = 'lowcut';
  readonly label = 'Low-cut';
  readonly icon = Wind;
  readonly description = 'Filtre passe-haut — coupe le grave sous la fréquence réglée';
  readonly defaultConfig: LowcutConfig = { freq: 80 };

  apply(registry: AudioSourceRegistry, regId: string, enabled: boolean, config: LowcutConfig): void {
    registry.setLowcut(regId, enabled, config.freq);
  }

  renderControls({ config, onChange }: AudioEffectControlProps<LowcutConfig>) {
    return (
      <LevelSlider
        label="Fréquence" value={config.freq}
        min={40} max={300} defaultValue={80} roundTo={5}
        format={v => `${v} Hz`}
        onChange={freq => onChange({ freq })}
      />
    );
  }
}

export const lowcutEffect = new LowcutEffectImpl();
